export default function objGet(obj, path) {
	if (!path) return obj;
	let parts = path.split('.');
	let part = undefined;
	while ((part = parts.shift()) && obj) {
		obj = obj[part];
	}
	return obj;
}